<template>
  <nav id="nav">
    <router-link :to="{ name: 'Home' }" id="hp-link">
      <img
        id="nav-logo"
        src="@/assets/csca-nav-icon.svg"
        alt="CS Capital Advisors"
      />
    </router-link>
    <nav id="nav-links">
      <router-link :to="{ name: 'Firm-Overview' }" class="nav-link"
        >Firm Overview</router-link
      >
      <router-link :to="{ name: 'Financial-Advisory' }" class="nav-link"
        >Financial Advisory</router-link
      >
      <router-link :to="{ name: 'Asset-Management' }" class="nav-link"
        >Asset Management</router-link
      >
      <router-link :to="{ name: 'Transactions' }" class="nav-link"
        >Transactions</router-link
      >
      <router-link :to="{ name: 'Leadership' }" class="nav-link"
        >Leadership</router-link
      >
      <router-link :to="{ name: 'Careers' }" class="nav-link"
        >Careers</router-link
      >
      <router-link :to="{ name: 'Contact' }" class="nav-link"
        >Contact</router-link
      >
    </nav>
    <div id="mobile-nav-toggle" @click="toggleMobileMenu">
      <div class="mobile-nav-block"></div>
      <div class="mobile-nav-block"></div>
      <div class="mobile-nav-block"></div>
    </div>
  </nav>
</template>

<script>
import { TweenMax, Power2 } from "gsap";
export default {
  data() {
    return {
      navOpen: false
    };
  },
  methods: {
    animateNav() {
      var els = [];
      els.push(document.getElementById("nav-logo"));
      var tempEls = document.querySelectorAll(".nav-link");
      for (var i = 0; i < tempEls.length; i++) {
        els.push(tempEls[i]);
      }
      TweenMax.staggerTo(
        els,
        0.7,
        { opacity: 1, transform: "translateX(0)", ease: Power2.easeOut },
        0.3
      );
    },
    animateMobileNav() {
      var navLinks = document.querySelectorAll(".nav-link");
      TweenMax.set(navLinks, { opacity: 0, transform: "translateX(30px)" });
      TweenMax.staggerTo(
        navLinks,
        0.6,
        { opacity: 1, transform: "translateX(0px)", ease: Power2.easeOut },
        0.1
      );
    },
    toggleMobileMenu() {
      document.getElementById("nav").classList.toggle("nav-open");
      if (!this.navOpen) {
        this.animateMobileNav();
        this.navOpen = true;
      } else {
        this.navOpen = false;
      }
    }
  },
  mounted() {
    this.animateNav();
  }
};
</script>

<style lang="scss" scoped>
#nav {
  z-index: 10;
  background:  #111d3c;
  background-image: linear-gradient(to right, #0f224e,  #111d3c);
  width: 100%;
  height: 100px;
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 48px;
  a {
    white-space: nowrap;
    color: #ffffff;
    font-family: europa, sans-serif;
    font-weight: 400;
    text-transform: none;
    transition: color 0.3s ease;
    &#hp-link {
      margin-left: 0;
    }
    &:hover {
      color: #dcb249;
      text-decoration: none;
    }
  }
  #nav-links {
    @media screen and (min-width: 961px) {
      width: 92%;
      display: flex;
      justify-content: space-between;
    }
    @media screen and (min-width: 1300px) {
      width: 75%;
    }
  }
  .nav-link,
  #nav-logo {
    display: inline-block;
    transform: translateX(30px);
    opacity: 0;
  }

  &.off-top {
    height: 50px;
  }
  #mobile-nav-toggle {
    display: none;
  }
}
@media screen and (max-width: 960px) {
  #nav {
    padding: 24px;
    height: 60px;
    a {
      margin: 0;
    }
    #nav-links {
      position: fixed;
      text-align: center;
      top: 60px;
      bottom: 0;
      left: 100%;
      width: 100%;
      padding-top: 48px;
      transition: all 0.4s ease-out;
      background:  #111d3c;
      a {
        font-size: 1.5rem;
        line-height: 3rem;
        font-weight: 300;
        margin: 0;
        display: block;
      }
    }
    #mobile-nav-toggle {
      display: block;
      position: absolute;
      height: 16px;
      width: 30px;
      top: 22px;
      right: 24px;
      transition: all 0.4s ease;
      .mobile-nav-block {
        position: absolute;
        right: 0;
        height: 2px;
        width: 30px;
        background: #ffffff;
        transition: all 0.4s ease;
        &:nth-child(2) {
          top: 7px;
        }
        &:nth-child(3) {
          top: 14px;
        }
      }
    }
    &.nav-open {
      #nav-links {
        left: 0;
      }
      #mobile-nav-toggle {
        transform-origin: center;
        transform: rotate(180deg);
        .mobile-nav-block {
          background: #dcb249;
          &:nth-child(1) {
            transform: rotate(45deg);
            top: 7px;
          }
          &:nth-child(2) {
            width: 0;
            right: 12px;
          }
          &:nth-child(3) {
            transform: rotate(-45deg);
            top: 7px;
          }
        }
      }
    }
  }
}
</style>
